/** @format */
import React from 'react';

import {
    LinkList,
    LinkListVariant, // eslint-disable-next-line @mpb-com/mpb/no-relative-import-across-modules -- Legacy code: do not use as an example.
} from '../../../../../../shared/components/link-list';
import { MobileLinksProps } from './types';

export const MobileLinks = ({ links }: MobileLinksProps) => {
    const flattenLinks = links.flatMap((linkList) => linkList.links);

    return <LinkList links={flattenLinks} variant={LinkListVariant.BLOCK} />;
};
